import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AppSettings} from '../../config/config';
import {map} from 'rxjs/operators';
import { apiConstants } from "../constant/apiConstant";

@Injectable()
export class SettingService {

  private _url = AppSettings.API_ENDPOINT;
  private URL_V3 = AppSettings.API_ENDPOINT_V3;
  private getTimeZoneList = apiConstants.getTimeZoneList;
  private getSchoolSettingListAPI = apiConstants.getSchoolSettingListAPI;
  private setSchoolTimeZone = apiConstants.setSchoolTimeZone;
  private setSchoolSetting = apiConstants.setSchoolSetting;
  headers: HttpHeaders;

  constructor(private http: HttpClient) {
    this.headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', localStorage.getItem('usertoken'));
  }


  fetchSchoolDetails() {
    const params = {};

    return this.http.post(this._url + '/settings/schoolDetails',
      params, {headers: this.headers})
      .pipe(map(res => res));
  }

  fetchOverViewDetails() {
    const params = {};

    return this.http.post(this._url + '/settings/overview',
      params, {headers: this.headers})
      .pipe(map(res => res));
  }

  fetchAccountDetails() {
    const params = {};
    return this.http.post(this._url + '/settings/account',
      params, {headers: this.headers})
      .pipe(map(res => res));
  }


  fetchinactivestudent(requestParams?: any) {
    const params = {
    page: requestParams?.page || 1,
    limit: requestParams?.limit || 10,
    searchText: requestParams?.searchText || "",
    academicId : requestParams?.academicId,
    sortBy: requestParams?.sortBy || "studentName",     
    sortOrder: requestParams?.sortOrder || "ASC",
    };
    return this.http.post(this._url + '/settings/deactivatedStudentList',
      params, {headers: this.headers})
      .pipe(map(res => res));
  }

  fetchinactivestaff(requestParams?: any) {
    const params = {
    page: requestParams?.page || 1,
    limit: requestParams?.limit || 10,
    searchText: requestParams?.searchText || "",
    sortBy: requestParams?.sortBy || "staffName",     
    sortOrder: requestParams?.sortOrder || "ASC", 
  };
    return this.http.post(this._url + '/settings/deactivatedStaffList',
      params, {headers: this.headers})
      .pipe(map(res => res));
  }

  fetchFeatureList() {
    const params = {};

    return this.http.post(this._url + '/settings/FeatureList',
      params, {headers: this.headers})
      .pipe(map(res => res));
  }

  fetchTimeZoneList(authToken) {
    const url = `${this.URL_V3 + this.getTimeZoneList}/?lang=en`;
    console.log("URL:", url); 
    const headers = new HttpHeaders({
    'Content-Type': 'application/json',
    "token": `${authToken}`
    });
   return this.http.get(url,  {headers: headers}).pipe(map(res => res));
  }

  setTimeZone(body, authToken) {
    const headers = new HttpHeaders({
      'Content-Type' : 'application/json',
      "token": `${authToken}`
    });
    return this.http.post(this.URL_V3 + this.setSchoolTimeZone,
      body, { headers: headers }).pipe(map(res => res));
  }

  fetchUpdateFeatureList(id, status) {
    const params = {pkSchoolFeatureId: id, ActiveStatus: status};

    return this.http.post(this._url + '/settings/UpdateFeature',
      params, {headers: this.headers})
      .pipe(map(res => res));
  }

  fetchUpdateUserList() {
    const params = {};

    return this.http.post(this._url + '/settings/UserList',
      params, {headers: this.headers})
      .pipe(map(res => res));
  }

  fetchSearchUserList(a) {
    const params = {search: a};

    return this.http.post(this._url + '/settings/searchUser',
      params, {headers: this.headers})
      .pipe(map(res => res));
  }

  updateSchoolDetails(schoolname, mobnumber, mailid, add, area, state, pincode, description, statusparent, statustaff) {
    const params = {
      SchoolName: schoolname,
      mobNumber: mobnumber,
      email: mailid,
      address: add,
      locality: area,
      state: state,
      pinCode: pincode,
      Description: description,
      ParentmessageLimit: statusparent,
      staffMessageLimit: statustaff
    };

    return this.http.post(this._url + '/settings/updateSchoolDetails',
      params, {headers: this.headers})
      .pipe(map(res => res));
  }


  addAdminUserDetails(mailid, username, psswd, cnfmpassword, mobnumber, accesstype, flist) {
    const params = {
      emailId: mailid,
      username: username,
      password: psswd,
      cnfmpassword: cnfmpassword,
      PhoneNumber: mobnumber,
      AccessType: accesstype,
      featurelist: flist
    };

    return this.http.post(this._url + '/settings/addNewUser',
      params, {headers: this.headers})
      .pipe(map(res => res));
  }

  getAdminUserDetails(schooladminid) {
    const params = {pkSchoolAdminsId: schooladminid};


    return this.http.post(this._url + '/settings/getUserDetails',
      params, {headers: this.headers})
      .pipe(map(res => res));
  }

  getAdminUserFeatureDetails(schooladmin) {
    const params = {pkSchoolAdminsId: schooladmin};

    return this.http.post(this._url + '/settings/getUserFeatureDetails',
      params, {headers: this.headers})
      .pipe(map(res => res));
  }

  updateUserPassword(password, adminId) {
    const params = {password: password, pkSchoolAdminsId: adminId};
    return this.http.post(this._url + '/settings/updateUserPassword',
      params, {headers: this.headers})
      .pipe(map(res => res));
  }

  updateAdminUserDetails(mailid, mobnumber, accesstype, status, fuserlst, schoolId) {
    const params = {
      emailId: mailid,
      PhoneNumber: mobnumber,
      AccessType: accesstype,
      AdminAccessStatus: status,
      featurelist: fuserlst,
      SchoolAdminsId: schoolId
    };


    return this.http.post(this._url + '/settings/UpdateUserFeatureDetails',
      params, {headers: this.headers})
      .pipe(map(res => res));
  }

  getAdminUserFeatureList() {
    const params = {};

    return this.http.post(this._url + '/settings/UserFeatureList',
      params, {headers: this.headers})
      .pipe(map(res => res));
  }

  reactivateStudent(id) {
    const params = {studentId: id};

    return this.http.post(this._url + '/settings/ReactiveStudent',
      params, {headers: this.headers})
      .pipe(map(res => res));
  }

  reactivatestaff(id) {
    const params = {staffId: id};

    return this.http.post(this._url + '/settings/ReactiveStaff',
      params, {headers: this.headers})
      .pipe(map(res => res));
  }

  deleteAdminUserDetails(deleteAdminUser) {
    const params = {pkSchoolAdminsId: deleteAdminUser};

    return this.http.post(this._url + '/settings/DeleteUser',
      params, {headers: this.headers})
      .pipe(map(res => res));
  }///updateGenerateRegIdSetting
  activateAdmin(adminId) {
    const params = {pkSchoolAdminsId: adminId};
    return this.http.post(this._url + '/settings/activateAdminUser',
      params, {headers: this.headers})
      .pipe(map(res => res));
  }

  updateGenerateRegIdSetting(generateRegId) {
    const params = {generateRegId: generateRegId};
    return this.http.post(this._url + '/settings/updateGenerateRegIdSetting',
      params, {headers: this.headers})
      .pipe(map(res => res));
  }

  createGradingSystemConfigService(gradeSysValue, AUTHTOKEN) {
    const params = gradeSysValue;
    return this.http.post(this._url + '/exam/createGradingSystemConfig',
      params, {headers: this.headers})
      .pipe(map(res => res));
  }

  getExamBoardService(AUTHTOKEN) {
    const params = {};
    return this.http.post(this._url + '/exam/getExamBoardList',
      params, {headers: this.headers})
      .pipe(map(res => res));
  }

  fetchClassStandardAndSectionService(AUTHTOKEN) {
    const params = {};
    return this.http.post(this._url + '/exam/getClassStandardAndSection',
      params, {headers: this.headers})
      .pipe(map(res => res));
  }

  getClassListByExamBoardService(ExamBoardId, AUTHTOKEN) {
    const params = {ExamBoardId: ExamBoardId};
    return this.http.post(this._url + '/exam/getClassListByExamBoard',
      params, {headers: this.headers})
      .pipe(map(res => res));
  }

  getExamGradeSystemByExamBoardService(ExamBoardId, AUTHTOKEN) {
    const params = {ExamBoardId: ExamBoardId};
    return this.http.post(this._url + '/exam/getExamGradeSystemByExamBoard',
      params, {headers: this.headers})
      .pipe(map(res => res));
  }
  fetchAcademicList(schoolId ,AUTHTOKEN) {
    const params = {schoolId};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/academiclist', params, {headers}).pipe(map(res => res));
  }

  fetchSchoolSettings(authToken) {
    const url = `${this.URL_V3 + this.getSchoolSettingListAPI}/?lang=en`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "token": `${authToken}`
    });
    return this.http.get(url, { headers: headers }).pipe(map(res => res));
  }

  setSchoolSettings(body, authToken) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "token": `${authToken}`
    });
    return this.http.put(this.URL_V3 + this.setSchoolSetting,
      body, { headers: headers }).pipe(map(res => res));
  }
}


